import { Directive, ElementRef, Inject, Input, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VmGlobalConfig, VM_GLOBAL_CONFIG } from '../../config/config.model';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[vmRemoveFromView]',
})
export class RemoveFromViewDirective implements OnInit {
  @Input() vmRemoveFromView = false;

  //header footer breadcums backnavigation selector array to remove on app if we have not configured on any microapp level.
  ComponentToRemoveOnApp = ['vm-breadcrumb', 'vm-footer', 'vm-header', 'vm-back-navigation'];
  queryParam: any;

  constructor(
    private el: ElementRef,
    @Inject(VM_GLOBAL_CONFIG) @Optional() private config: VmGlobalConfig,
    @Optional() private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((data) => {
      if (data.embeddedWebApp) {
        this.queryParam = data;
        this.checkParamsForAppContainer();
      }
      let sessionVal;

      if (isPlatformBrowser(this.platformId)) {
        sessionVal = JSON.parse(sessionStorage.getItem('webAppContainerCookies') || '{}');
      }

      if (sessionVal?.isContainerInsideApp) {
        if (
          !this.vmRemoveFromView ||
          (this.config?.components || this.ComponentToRemoveOnApp).includes(
            this.el?.nativeElement?.parentElement?.tagName?.toLowerCase()
          )
        ) {
          this.el.nativeElement.remove();
        }
      }
    });
  }

  private checkParamsForAppContainer() {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { embeddedWebApp = '', utm_campaign } = this.queryParam || {};
    const isWebContainerInsideApp = embeddedWebApp.toLowerCase() === 'true';

    if (isWebContainerInsideApp) {
      sessionStorage.setItem(
        'webAppContainerCookies',

        JSON.stringify({
          isContainerInsideApp: isWebContainerInsideApp,

          isDeepLinkForMobileUser: /mobile_cus_app/gi.test(utm_campaign),

          isDeepLinkForCableUser: /cable_cus_app/gi.test(utm_campaign),
          isDeepLinkForLandlineTile: this.activatedRoute?.snapshot?.params?.uid?.toLowerCase() === 'landline',
        })
      );
    }
  }
}
